import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { IUnidadeMedida } from '../../model';

@Injectable()
export class UnidadeMedidaService extends EntityService<IUnidadeMedida> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      baseEntityEndPoint: 'unidademedida',
      urlBackend: configService.backendURL
    });
  }
}
